module.exports = __webpack_public_path__ + "media/images/athletes/1748-f0c1a630df5980d14b7a965044789fbc.png";